import { render, staticRenderFns } from "./DepartmentFilters.vue?vue&type=template&id=270e965e&"
import script from "./DepartmentFilters.vue?vue&type=script&lang=js&"
export * from "./DepartmentFilters.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentFilters.vue?vue&type=style&index=0&id=270e965e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports